import { render, staticRenderFns } from "./expressDetailDialog.vue?vue&type=template&id=72fd8c62&scoped=true"
import script from "./expressDetailDialog.vue?vue&type=script&lang=js"
export * from "./expressDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./expressDetailDialog.vue?vue&type=style&index=0&id=72fd8c62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fd8c62",
  null
  
)

export default component.exports